import { FetchResult } from '@apollo/client'
import { client } from '../..'
import { Country, SetNextAppraisalSeasonOpeningDateMutation, SetNextAppraisalSeasonOpeningDateMutationVariables } from '../../types'
import { SET_NEXT_APPRAISAL_SEASON_OPENING_DATE } from './Mutations'
import { GET_APPRAISAL_SEASON_OPENING_INFO } from './Queries'

export const setNextAppraisalSeasonOpeningDate = async (
  companyId: string,
  country: Country,
  year: number,
  openingMonth: number,
  openingYear: number,
): Promise<FetchResult<SetNextAppraisalSeasonOpeningDateMutation>> => {
  const mutationResult = await client.mutate<SetNextAppraisalSeasonOpeningDateMutation, SetNextAppraisalSeasonOpeningDateMutationVariables>(
    {
      mutation: SET_NEXT_APPRAISAL_SEASON_OPENING_DATE,
      variables: {
        companyId,
        country,
        year,
        openingMonth,
        openingYear,
      },
    },
  )

  await client.query({
    query: GET_APPRAISAL_SEASON_OPENING_INFO,
    variables: { companyId, country },
    fetchPolicy: 'network-only',
  })

  return mutationResult
}
